import { Entity, Path } from '@/types/diagram';
import { Threat } from '@/types/threat';
import { throwApiError } from '@/lib/errors';

const BACKEND_BASE = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';

interface DiagramData {
  entities: Entity[];
  paths: Path[];
  threats: Threat[];
  project_info?: {
    name?: string;
    description?: string;
  };
}

interface CompleteNotesResponse {
  system_information?: string;
  management_summary?: string;
  scope?: string;
  auth_concept?: string;
}

export const aiService = {
  completeNotes: async (
    diagramData: DiagramData,
    selectedSections: string[]
  ): Promise<CompleteNotesResponse> => {
    const response = await fetch(`${BACKEND_BASE}/api/ai/complete-notes`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        diagram_data: diagramData,
        selected_sections: selectedSections,
      }),
    });

    if (!response.ok) {
      await throwApiError(response, 'AI completion failed');
    }

    return response.json();
  },

  enrichThreat: async (
    threat: Record<string, unknown>,
    diagramData: DiagramData,
    fieldsToGenerate: string[]
  ): Promise<Record<string, string>> => {
    const response = await fetch(`${BACKEND_BASE}/api/ai/enrich-threat`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        threat,
        diagram_data: diagramData,
        fields_to_generate: fieldsToGenerate,
      }),
    });

    if (!response.ok) {
      await throwApiError(response, 'Threat enrichment failed');
    }

    return response.json() as Promise<Record<string, string>>;
  },
};
